import axiosInstance from "./axiosInstance";
import { BASE_URL } from "../constants/applicationConfig";

const BASE_URL_MEAL_PLAN = `${BASE_URL}/api/meal-plan`;

export class MealPlanApi {
  static async fetchMealPlan(weekStartDate) {
    return (
      await axiosInstance.get(`${BASE_URL_MEAL_PLAN}`, {
        params: { weekStartDate },
      })
    ).data;
  }

  static async fetchThisWeekMealPlan() {
    return (await axiosInstance.get(`${BASE_URL_MEAL_PLAN}`)).data;
  }

  static async updateMealPlan(
    updateMealPlanRequest,
    dayCode,
    mealCode,
    weekStartDate,
  ) {
    const response = await axiosInstance.put(
      `${BASE_URL_MEAL_PLAN}/${dayCode}/${mealCode}`,
      updateMealPlanRequest,
      { params: { weekStartDate } },
    );
    return response.data;
  }

  static async clearMealPlan(weekStartDate) {
    return await axiosInstance.delete(`${BASE_URL_MEAL_PLAN}`, {
      params: { weekStartDate },
    });
  }

  static async clearDays(dayCodes, weekStartDate) {
    return await axiosInstance.delete(`${BASE_URL_MEAL_PLAN}/days`, {
      data: { dayCodes },
      params: { weekStartDate },
    });
  }
}
